import { Shield, AlertTriangle, AlertOctagon, Activity } from 'lucide-react';

export const cveMetrics = [
  {
    label: 'Total CVEs',
    value: '1,245',
    trend: '+23',
    icon: Shield,
    color: 'text-blue-500'
  },
  {
    label: 'Critical CVEs',
    value: '12',
    trend: '+3',
    icon: AlertOctagon,
    color: 'text-red-500'
  },
  {
    label: 'High CVEs',
    value: '45',
    trend: '+8',
    icon: AlertTriangle,
    color: 'text-orange-500'
  },
  {
    label: 'Active Exploits',
    value: '8',
    trend: '+2',
    icon: Activity,
    color: 'text-purple-500'
  }
];

export const recentCVEs = [
  {
    id: 'CVE-2024-1234',
    severity: 'Critical',
    description: 'Remote code execution vulnerability in OpenSSL',
    published: '2h ago',
    cvss: 9.8
  },
  {
    id: 'CVE-2024-5678',
    severity: 'High',
    description: 'SQL injection vulnerability in popular CMS',
    published: '4h ago',
    cvss: 8.5
  },
  {
    id: 'CVE-2024-9012',
    severity: 'Medium',
    description: 'Cross-site scripting vulnerability in web framework',
    published: '6h ago',
    cvss: 6.5
  }
];

export const affectedAssets = [
  {
    name: 'Web Application Server',
    vulnerableCVEs: 5,
    riskLevel: 'High'
  },
  {
    name: 'Database Cluster',
    vulnerableCVEs: 3,
    riskLevel: 'Medium'
  },
  {
    name: 'Load Balancer',
    vulnerableCVEs: 2,
    riskLevel: 'Low'
  }
];

export const cvesByCategory = [
  {
    name: 'Remote Code Execution',
    count: 156,
    percentage: 35,
    trend: '+12',
    color: 'text-red-500'
  },
  {
    name: 'SQL Injection',
    count: 89,
    percentage: 20,
    trend: '-5',
    color: 'text-orange-500'
  },
  {
    name: 'Cross-Site Scripting',
    count: 134,
    percentage: 30,
    trend: '+8',
    color: 'text-yellow-500'
  }
];